// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__KaaQc","timeDisplay":"Timer_timeDisplay__twyhE","progressBar":"Timer_progressBar__u8Y9z"};